/** Tanggal operasional dapur/delman (Asia/Jakarta) sebagai YYYY-MM-DD. */
export function kitchenTodayISO(now = new Date()): string {
  return new Intl.DateTimeFormat('en-CA', {
    timeZone: 'Asia/Jakarta',
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
  }).format(now)
}

/** Kemarin (Asia/Jakarta) sebagai YYYY-MM-DD. */
export function kitchenYesterdayISO(now = new Date()): string {
  const shifted = new Date(now.getTime() - 26 * 60 * 60 * 1000)
  const today = kitchenTodayISO(now)
  const candidate = kitchenTodayISO(shifted)
  if (candidate !== today) return candidate
  return kitchenTodayISO(new Date(now.getTime() - 36 * 60 * 60 * 1000))
}

/** Besok (Asia/Jakarta) sebagai YYYY-MM-DD. */
export function kitchenTomorrowISO(now = new Date()): string {
  // Geser 26 jam lalu format ke tanggal Jakarta → aman melewati DST-less WIB.
  const shifted = new Date(now.getTime() + 26 * 60 * 60 * 1000)
  const today = kitchenTodayISO(now)
  const candidate = kitchenTodayISO(shifted)
  if (candidate !== today) return candidate
  const shifted2 = new Date(now.getTime() + 36 * 60 * 60 * 1000)
  return kitchenTodayISO(shifted2)
}

/** YYYYMMDD Asia/Jakarta — kode dokumen / id lokal. */
export function kitchenTodayCompact(now = new Date()): string {
  return kitchenTodayISO(now).replaceAll('-', '')
}

export function formatTripDateLabel(iso: string, todayIso = kitchenTodayISO()): string {
  if (!iso) return todayIso
  if (iso === todayIso) return 'Hari ini'
  if (iso === kitchenTomorrowISO()) return 'Besok'
  const [y, m, d] = iso.split('-')
  if (!y || !m || !d) return iso
  return `${d}/${m}/${y.slice(2)}`
}
